export default __webpack_public_path__ + "static/media/Q7_0_resized.9406e578.jpg";